import axios from 'axios';
import { apiBaseUrl } from '../config';

axios.defaults.withCredentials = true;
axios.defaults.headers.common['Content-Type'] = 'application/json';

const api = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      if (window.location.pathname !== '/signin') {
        window.location.href = '/signin';
      }
    }
    return Promise.reject(error);
  }
);

export const contactAPI = {
  submitContact: (data) => api.post('/contact/sendcontactmessage', data),
  sendEmailOTP: ({ email, name, turnstileToken }) =>
    api.post('/verification', { method: 'send', type: 'email', identifier: email, name, event: 'contact', turnstileToken }),
  verifyEmailOTP: ({ email, code, turnstileToken }) =>
    api.post('/verification', { method: 'verify', type: 'email', identifier: email, code, turnstileToken }),
};

export const verificationAPI = {
  check: (data) => api.post('/verification', { method: 'send', ...data }),
  verify: (data) => api.post('/verification', { method: 'verify', ...data }),
};

export default api;
